import React, {Component} from 'react';
import {Button} from 'reactstrap';
import history from '../history';
import './PageNotFound.css';
import App from '../App';

class PageNotFound extends Component {
    render() {
        return (
            <App {...this.props}>
                <div className="error-message">
                    <h1>Error - Page Not Found</h1>
                    <p>Oops look like the page you are looking for does not exist.</p>
                    <p>Please go to the home page by clicking the button below.</p>
                    <Button className="home-button" onClick={()=>history.replace("/")} outline color="primary">Home</Button>
                </div>
            </App>
        );
    }
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/errors/PageNotFound.js